import React from 'react';
import styles from './CallToActionBtn.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBook, faEnvelope} from '@fortawesome/free-solid-svg-icons';
import {faFacebookSquare, faTwitterSquare} from '@fortawesome/free-brands-svg-icons';
import audioteka from '../../assets/audioteka.png';


const callToActionBtn = (props) => {
    if (props.facebook) {
        return (
            <div onClick={() => window.open("https://www.facebook.com/MaciejLewandowskiOficjalnie", "_blank")} className={styles.mainDivContact}>
                <FontAwesomeIcon className={styles.contactIcons} icon={faFacebookSquare}/>
                <span className={styles.contactSpan}>facebook</span>
            </div>
        )
    }
    if (props.twitter) {
        return (
            <div className={styles.mainDivContact}>
                <FontAwesomeIcon className={styles.contactIcons} icon={faTwitterSquare}/>
                <span className={styles.contactSpan}>twitter</span>
            </div>
        )
    }
    if (props.mail) {
        return (
            <div className={styles.mainDivContact}>
                <FontAwesomeIcon className={styles.contactIcons} icon={faEnvelope}/>
                <span className={styles.contactSpan}>mail</span>
            </div>
        )
    }
    if (props.audioteka) {
        return (
            <div onClick={() => window.open("https://audioteka.com/pl/audiobook/cienie-nowego-orleanu", "_blank")} className={styles.mainDivAudioteka}>
                <span>Audiobook na</span>
                <img src={audioteka} alt="audioteka logo"/>
            </div>
        )
    }

    if (props.cienie){
        return (
        <div onClick={() => window.open("http://bit.ly/CienieNowegoOrleanu", "_blank")} className={styles.mainDiv}>
            <FontAwesomeIcon icon={faBook}/>
            <span>O książce  </span>
        </div>  
        )      
    }
    return (
        <div onClick={() => window.open("https://www.ceneo.pl/43470568", "_blank")} className={styles.mainDiv}>
            <FontAwesomeIcon icon={faBook}/>
            <span>O książce  </span>
        </div>
    )

};

export default callToActionBtn;


// WEBPACK FOOTER //
// ./src/components/CallToActionBtn/CallToActionBtn.js